module.exports = __webpack_public_path__ + "static/media/landing-page-theme-feature-10.1acc0502.jpg";